import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";
import droneImg from "../Assets/Images/Dashboard/drone-img.png";
import robitcsImg from "../Assets/Images/Dashboard/robotics-img.png";
const SelectSection = () => {
  let navigate = useNavigate();

  const handleSectionClick = (section) => {
    localStorage.setItem("selectedSection", section);
    navigate("/dashboard");
    //trying to reload the page after redirection
    window.location.reload();
  };

  useEffect(()=>{
    // window.history.replaceState(null, "", "/");
  },[])

  useEffect(() => {
    // Prevent going back to the previous page after logging out
    const clearHistory = () => {
      window.history.pushState(null, window.location.pathname);
      window.onpopstate = () => {
        navigate("/select-section");
      };
    };
    clearHistory();
    return () => {
      window.onpopstate = null;
    };
  }, [navigate]);

  return (
    <section className="selected-section">
      <p className="main-title">Choose Your Section</p>
      <div className="row text-center">
        <div className="col-6" onClick={() => handleSectionClick("Robotics")}>
          <div style={{cursor:'pointer'}}>
            <img src={robitcsImg} alt="robitcsImg" className="img-fluid" />
            <p>Robotics</p>
          </div>
        </div>
        <div className="col-6" onClick={() => handleSectionClick("Drone")}>
          <div style={{cursor:'pointer'}}>
            <img src={droneImg} alt="droneImg" className="img-fluid" />
            <p>Drone</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectSection;
